export interface ClientConfig {
  backend: string;
  sso: boolean;
  ssoV1: boolean;
  ssoLabel: string;   // display name in the button e.g. "FRANKLIN TEMPLETON"
  ssoUrl: string;     // SSO redirect URL (empty string if sso: false)
}

const DEFAULT_BACKEND = 'https://stgusbe.web.moocpedia.com/';

export const LOGIN_CONFIG: Record<string, ClientConfig> = {

  // ─────────────────────────────────────────────
  // COLORADO  —  BE: https://epprweb.continualengine.com/
  // ─────────────────────────────────────────────
  'coloradosprings.prep.continualengine.com': {
    backend:  'https://epprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'COLORADO SPRINGS',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-sp-slc',
  },
  'valencia.prep.continualengine.com': {
    backend:  'https://epprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'VALENCIA',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-19vlc',
  },
  'portal.prep.continualengine.com': {
    backend:  'https://epprweb.continualengine.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'isu.prep.continualengine.com': {
    backend:  'https://epprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'INDIANA STATE UNIVERSITY',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-0226usi',
  },

  // ─────────────────────────────────────────────
  // EL PASO  —  BE: https://clsprweb.continualengine.com/
  // ─────────────────────────────────────────────
  'elpaso.prep.continualengine.com': {
    backend:  'https://clsprweb.continualengine.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'app.prep.continualengine.com': {
    backend:  'https://clsprweb.continualengine.com/',
    sso:      false,
    ssoV1:    true,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'harpercollege.prep.continualengine.com': {
    backend:  'https://clsprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'HARPER COLLEGE',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-0316hr',
  },
  'miamioh.prep.continualengine.com': {
    backend:  'https://clsprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'MIAMI UNIVERSITY',
    ssoUrl:   'https://us-central1-sso-myathina-function.cloudfunctions.net/app/login?tenant=miami',
  },
  'palmbeach.prep.continualengine.com': {
    backend:  'https://clsprweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'PALM BEACH COUNTY BOARD COUNTY COMMISSIONERS',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-0325pmb',
  },
  'vt.prep.continualengine.com': {
    backend:  'https://clsprweb.continualengine.com/',  
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'VIRGINIA TECH',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-sp-rg', 
  },

  // ─────────────────────────────────────────────
  // EFSA  —  BE: https://efsaweb.continualengine.com/
  // ─────────────────────────────────────────────
  'efsa-prep.netlify.app': {
    backend:  'https://efsaweb.continualengine.com/',
    sso:      false,
    ssoV1:    true,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'efsa.prep.continualengine.com': {
    backend:  'https://efsaweb.continualengine.com/',
    sso:      false,
    ssoV1:    true,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'lang-es-prep-console.netlify.app': {
    backend:  'https://efsaweb.continualengine.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'coloradomountain.prep.continualengine.com': {
    backend:  'https://efsaweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'COLORADO MOUNTAIN',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-sp-mlc',
  },
  'ft.prep.continualengine.com': {
    backend:  'https://efsaweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'FRANKLIN TEMPLETON',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-sptf',
  },
  'stanford.prep.continualengine.com': {
    backend:  'https://efsaweb.continualengine.com/',
    sso:      true,
    ssoV1:    false,
    ssoLabel: 'STANFORD UNIVERSITY',
    ssoUrl:   'https://sso.cnfsp.moocpedia.com/simplesaml/module.php/core/authenticate.php?as=default-sp-ts',
  },

  // ─────────────────────────────────────────────
  // RSP & DEMO
  // ─────────────────────────────────────────────
  'rsp-prep.netlify.app': {
    backend:  'https://stgprp.web.moocpedia.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'demo-prep.netlify.app': {
    backend:  'https://demoprep.web.moocpedia.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
  },

  // ─────────────────────────────────────────────
  // KH
  // ─────────────────────────────────────────────
  'rsp-kh-prep.netlify.app': {
    backend:  'https://apikhbe.continualengine.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',  
  },

  // ─────────────────────────────────────────────
  // Scalejustice
  // ─────────────────────────────────────────────
  'scalejustice-prep.netlify.app': {
    backend:  'https://prpbesj.continualengine.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',  
  },
  'scalejustice.prep.continualengine.com': {
    backend:  'https://prpbesj.continualengine.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',  
  },

  // ─────────────────────────────────────────────
  // CONSOLE PROD
  // ─────────────────────────────────────────────
  'console.prep.continualengine.com': {
    backend:  'https://prepapi.web.continualengine.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
  },

  // ─────────────────────────────────────────────
  // STAGE
  // ─────────────────────────────────────────────
  'newstaging-prep.netlify.app': {
    backend:  'https://stgusbe.web.moocpedia.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'stage-vt-platform.netlify.app': {
    backend:  'https://stgusbe.web.moocpedia.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
  },

  // ─────────────────────────────────────────────
  // CLONE
  // ─────────────────────────────────────────────
  'clone-prep.netlify.app': {
    backend:  'https://clonecepoc.web.moocpedia.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'clone-prep-v1.netlify.app': {
    backend:  'https://clonecepoc.web.moocpedia.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
  },
  'clone-prep-b1.netlify.app': {
    backend:  'https://clonecepoc.web.moocpedia.com/',
    sso:      false,
    ssoV1:    false,
    ssoLabel: '',
    ssoUrl:   '',
  },
};

const DEFAULT_CONFIG: ClientConfig = {
  backend:  DEFAULT_BACKEND,
  sso:      false,
  ssoV1:    false,
  ssoLabel: '',
  ssoUrl:   '',
};

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const resolvedConfig = LOGIN_CONFIG[hostname] ?? DEFAULT_CONFIG;

export const environment = {
  production: true,
  backend:    resolvedConfig.backend,
  sso:        resolvedConfig.sso,
  ssoV1:      resolvedConfig.ssoV1,
  ssoLabel:   resolvedConfig.ssoLabel,
  ssoUrl:     resolvedConfig.ssoUrl,
};